import React, { useMemo, useRef } from 'react';
import Form from 'react-bootstrap/esm/Form';
import { useDispatch, useSelector } from 'react-redux';
import { IReducer } from '../../../../../../../../redux/configureStore';
import { setAccountOption } from '../../../../../../../../redux/fetchActions/legadoPage/faresApp';
import Wrapper from '../../../../../../../../shared/components/Wrapper';

function SetAccountType() {
  const dispatch = useDispatch();
  const faresFilterState = useSelector(
    (reducer: IReducer) => reducer.faresFilter
  );

  const isDisable = useRef(true);

  function setAccount(event: React.FormEvent<any>) {
    const { value } = event.currentTarget;
    dispatch(setAccountOption(value));
  }

  useMemo(() => {
    if (
      faresFilterState.fare === 'boleto' ||
      faresFilterState.fare === 'mensalidade'
    ) {
      isDisable.current = false;
    } else {
      isDisable.current = true;
    }
  }, [faresFilterState.fare]);

  return (
    <Wrapper.Default isActive={!isDisable.current} flexDirection="row">
      <span>Conta:</span>
      <Form.Control
        as="select"
        style={{ width: '10.5rem', margin: '0 0.5rem 0 0.25rem' }}
        value={faresFilterState.account}
        onChange={(event) => setAccount(event)}>
        <option key={1} value="todos">
          Todas
        </option>
        <option key={2} value="consignada">
          {1} - Consignada
        </option>
        <option key={3} value="escrow">
          {2} - Escrow
        </option>
        <option key={4} value="pf">
          {3} - Movimento - Pessoa Física
        </option>
        <option key={5} value="pj">
          {4} - Movimento - Pessoa Jurídica
        </option>
      </Form.Control>
    </Wrapper.Default>
  );
}

export default SetAccountType;
